var T = Object.defineProperty;
var R = (s, t, r) => t in s ? T(s, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : s[t] = r;
var e = (s, t, r) => (R(s, typeof t != "symbol" ? t + "" : t, r), r);
import { fabric as a } from "fabric";
import "@turf/turf";
import "./index.es175.js";
import "./index.es176.js";
import { createFabricImageFromSvgString as H } from "./index.es454.js";
const v = `<svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.3 0C3.9804 0 2.1 1.8804 2.1 4.2V5.70523C1.90217 5.74858 1.7123 5.8117 1.52883 5.90518C1.00197 6.17363 0.573628 6.60197 0.305183 7.12883C0.132079 7.46856 0.0630841 7.83025 0.0309364 8.22372C-1.5508e-05 8.60256 -8.36652e-06 9.06761 2.88154e-07 9.63108V9.96891C-8.36652e-06 10.5324 -1.55106e-05 10.9974 0.0309364 11.3763C0.0630841 11.7697 0.132079 12.1314 0.305183 12.4712C0.573628 12.998 1.00197 13.4264 1.52883 13.6948C1.86856 13.8679 2.23025 13.9369 2.62372 13.9691C3.00256 14 3.46762 14 4.03111 14H8.56889C9.13238 14 9.59744 14 9.97628 13.9691C10.3697 13.9369 10.7314 13.8679 11.0712 13.6948C11.598 13.4264 12.0264 12.998 12.2948 12.4712C12.4679 12.1314 12.5369 11.7697 12.5691 11.3763C12.6 10.9974 12.6 10.5324 12.6 9.96893V9.63107C12.6 9.0676 12.6 8.60256 12.5691 8.22372C12.5369 7.83025 12.4679 7.46856 12.2948 7.12883C12.0264 6.60197 11.598 6.17363 11.0712 5.90518C10.8877 5.8117 10.6978 5.74858 10.5 5.70523V4.2C10.5 1.8804 8.6196 0 6.3 0ZM9.1 5.60114V4.2C9.1 2.6536 7.8464 1.4 6.3 1.4C4.7536 1.4 3.5 2.6536 3.5 4.2V5.60114C3.66639 5.59999 3.84327 5.6 4.03108 5.6H8.56891C8.75672 5.6 8.93361 5.59999 9.1 5.60114Z" fill="white"/>
</svg>`, g = 8, A = 16, G = {
  300: { value: 300, next: 400 },
  400: { value: 400, next: 600 },
  600: { value: 600, next: 700 },
  700: { value: 700, next: 900 },
  900: { value: 900, next: 900 }
}, o = {
  global: {
    fontStyle: "normal",
    fontSize: "13",
    fontWeight: { value: 400, next: 600 },
    lineHeight: 1.5
  },
  placeholder: {
    fillColor: "#FFFFFF",
    fontColor: "#2F3C44",
    fontSize: 18,
    plusContainer: {
      fillColor: "#5e63e5"
    }
  },
  badges: {
    container: {
      fillColor: "#FFFFFF"
    },
    fontColor: "#2F3C44"
  }
}, W = (s, t) => {
  switch (s) {
    case "None":
      return "";
    case "Custom":
      return t;
    default:
      return s;
  }
}, X = (s) => {
  switch (s) {
    case "a-to-b":
      return { start: "A", end: "B" };
    case "b-to-a":
      return { start: "B", end: "A" };
    default:
      return { start: "", end: "" };
  }
};
class Y {
  constructor(t) {
    e(this, "objType");
    e(this, "layerGroupId");
    e(this, "subLayerId");
    e(this, "combinedLayerId");
    e(this, "styleType");
    e(this, "labelInfo");
    e(this, "roadLabelCalloutBoxConfig");
    e(this, "container");
    e(this, "point");
    e(this, "nameTextbox");
    e(this, "label");
    e(this, "count");
    e(this, "plus");
    e(this, "plusContainer");
    e(this, "startBadge");
    e(this, "endBadge");
    e(this, "plusBadge");
    e(this, "lockBadge");
    e(this, "fullRoadLabel");
    e(this, "generate", async () => {
      const t = [], r = parseInt(
        this.roadLabelCalloutBoxConfig.additionalStyleSize || o.global.fontSize
      ), p = G[this.roadLabelCalloutBoxConfig.additionalStyleFontWeight] || o.global.fontWeight, B = p.value, m = p.next, f = this.roadLabelCalloutBoxConfig.additionalStyleFontColorOpacity / 100, c = this.labelInfo.tempLabel === !0, b = c ? o.placeholder.fontColor : this.roadLabelCalloutBoxConfig.additionalStyleFontColor, I = c ? o.placeholder.fillColor : this.roadLabelCalloutBoxConfig.bgFillColor, S = this.labelInfo.trafficVolumeMetric === "a+b" ? this.labelInfo.a_to_b + this.labelInfo.b_to_a : this.labelInfo.trafficVolumeMetric === "a-to-b" ? this.labelInfo.a_to_b : this.labelInfo.b_to_a, w = W(
        this.roadLabelCalloutBoxConfig.roadLabelType,
        this.roadLabelCalloutBoxConfig.roadLabelCustomText
      ), C = X(this.labelInfo.trafficDirection), u = r / 2 - 8.5;
      let i = 0;
      if (C.start && this.labelInfo.isEditing) {
        const l = new a.Text(C.start, {
          width: 20,
          height: 20,
          left: 0,
          top: 0,
          originX: "center",
          originY: "center",
          textAlign: "center",
          fill: o.badges.fontColor,
          fontFamily: this.roadLabelCalloutBoxConfig.additionalStyleFont,
          fontStyle: o.global.fontStyle,
          fontSize: r,
          fontWeight: 600,
          lineHeight: o.global.lineHeight
        }), n = new a.Rect({
          left: 0,
          width: 20,
          top: 0,
          height: 20,
          originX: "center",
          originY: "center",
          fill: o.badges.container.fillColor,
          opacity: this.roadLabelCalloutBoxConfig.bgFillColorOpacity,
          rx: 10,
          ry: 10
        }), d = new a.Group([n, l], {
          left: i,
          width: 20,
          top: u,
          height: 20
        }), h = n.getBoundingRect();
        i += h.width + g, this.startBadge = d, t.push(d);
      }
      const x = new a.Text(new Intl.NumberFormat("en-US").format(S), {
        width: 72,
        textAlign: "left",
        fill: b,
        left: i,
        fontFamily: this.roadLabelCalloutBoxConfig.additionalStyleFont,
        fontStyle: o.global.fontStyle,
        fontWeight: m,
        fontSize: r,
        lineHeight: o.global.lineHeight,
        opacity: f
      }), y = x.getBoundingRect();
      if (i += y.width + g, this.count = x, t.push(x), w) {
        const l = new a.Text(w, {
          width: 72,
          left: i,
          textAlign: "left",
          fill: b,
          fontFamily: this.roadLabelCalloutBoxConfig.additionalStyleFont,
          fontStyle: o.global.fontStyle,
          fontWeight: B,
          fontSize: r,
          lineHeight: o.global.lineHeight,
          opacity: f
        }), n = l.getBoundingRect();
        i += n.width + g, this.label = l, t.push(l);
      }
      if (this.labelInfo.roadName && this.labelInfo.styleConfig.showRoadLabelNames) {
        const l = new a.Text(this.labelInfo.roadName, {
          width: 72,
          left: i,
          textAlign: "left",
          fill: b,
          fontFamily: this.roadLabelCalloutBoxConfig.additionalStyleFont,
          fontStyle: o.global.fontStyle,
          fontWeight: B,
          fontSize: r,
          lineHeight: o.global.lineHeight,
          opacity: f
        }), n = l.getBoundingRect();
        i += n.width + g, this.nameTextbox = l, t.push(l);
      }
      if (C.end && this.labelInfo.isEditing) {
        const l = new a.Text(C.end, {
          width: 20,
          height: 20,
          left: 0,
          top: 0,
          originX: "center",
          originY: "center",
          textAlign: "center",
          fill: o.badges.fontColor,
          fontFamily: this.roadLabelCalloutBoxConfig.additionalStyleFont,
          fontStyle: o.global.fontStyle,
          fontSize: r,
          fontWeight: 600,
          lineHeight: o.global.lineHeight
        }), n = new a.Rect({
          left: 0,
          width: 20,
          top: 0,
          height: 20,
          originX: "center",
          originY: "center",
          fill: o.badges.container.fillColor,
          opacity: this.roadLabelCalloutBoxConfig.bgFillColorOpacity,
          rx: 10,
          ry: 10
        }), d = new a.Group([n, l], {
          left: i,
          width: 20,
          top: u,
          height: 20
        }), h = n.getBoundingRect();
        i += h.width + g, this.endBadge = d, t.push(d);
      }
      if (c) {
        const l = new a.Text("+", {
          width: 20,
          height: 20,
          left: 0,
          top: 0,
          originX: "center",
          originY: "center",
          textAlign: "center",
          fill: o.placeholder.fillColor,
          fontFamily: this.roadLabelCalloutBoxConfig.additionalStyleFont,
          fontStyle: o.global.fontStyle,
          fontSize: o.placeholder.fontSize,
          fontWeight: 600,
          lineHeight: o.global.lineHeight
        }), n = new a.Rect({
          left: 0,
          width: 20,
          top: 0,
          height: 20,
          originX: "center",
          originY: "center",
          fill: o.placeholder.plusContainer.fillColor,
          rx: 10,
          ry: 10
        }), d = new a.Group([n, l], {
          left: i,
          width: 20,
          top: u,
          height: 20
        }), h = n.getBoundingRect();
        i += h.width + g, this.plusBadge = d, t.push(d);
      }
      if (this.labelInfo.isLocked && this.labelInfo.isEditing) {
        const l = await H(v);
        if (l) {
          this.lockBadge = l, this.lockBadge.set({
            left: i,
            top: -3.5,
            width: 20,
            height: 20,
            fill: b,
            opacity: f
          });
          const n = l.getBoundingRect();
          i += n.width + g, t.push(l);
        }
      }
      const L = i + g, F = new a.Rect({
        left: L / 2 - g,
        width: L,
        top: y.height / 2,
        height: y.height + A,
        originX: "center",
        originY: "center",
        fill: I,
        opacity: c ? 1 : this.roadLabelCalloutBoxConfig.bgEnabled && this.roadLabelCalloutBoxConfig.bgFillColorOpacity / 100 || 0.01,
        rx: this.roadLabelCalloutBoxConfig.bgCornerRadius,
        ry: this.roadLabelCalloutBoxConfig.bgCornerRadius
      });
      return this.container = F, t.push(F), t;
    });
    e(this, "getTenantsCalloutBoxObjs", () => (this.fullRoadLabel = new a.Group(
      [
        this.container,
        this.nameTextbox,
        this.label,
        this.count,
        this.plusContainer,
        this.plus,
        this.startBadge,
        this.endBadge,
        this.plusBadge,
        this.lockBadge
      ].filter((t) => t),
      {
        centeredRotation: !0,
        angle: this.labelInfo.angle - 90
      }
    ), this.fullRoadLabel));
    e(this, "updateStyle", (t, r = "idle") => {
      this.styleType = t;
    });
    t = {
      ...t
    }, this.layerGroupId = t.layerGroupId, this.subLayerId = t.subLayerId, this.combinedLayerId = t.combinedLayerId, this.objType = "RoadLabel", this.styleType = t.styleType, this.labelInfo = t.labelInfo, this.roadLabelCalloutBoxConfig = t.labelInfo.styleConfig;
  }
}
export {
  Y as RoadLabel
};
//# sourceMappingURL=index.es497.js.map
